import { FormControl, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { useSetFontSize } from '../../../entities/event-settings';
import type { EventSettingsGridType } from '../../../entities/event-settings';
import { userEventSettings } from '../../../state/user';
import type { GridSettings } from '../../../types';

type FontSize = GridSettings['fontSize'];

type Props = {
  gridType: EventSettingsGridType;
};

type EventSettingsGridKey = 'incidentGridSettings' | 'drsGridSettings' | 'pmpGridSettings';

const gridSettingsKeyMap: Record<EventSettingsGridType, EventSettingsGridKey> = {
  incident: 'incidentGridSettings',
  drs: 'drsGridSettings',
  pmp: 'pmpGridSettings',
};

const FONT_SIZE_OPTIONS: { value: FontSize; labelKey: string }[] = [
  { value: 'md', labelKey: 'font-size-md' },
  { value: 'lg', labelKey: 'font-size-lg' },
  { value: 'xl', labelKey: 'font-size-xl' },
];

export const FontSizeControl = ({ gridType }: Props) => {
  const { t } = useTranslation();
  const userEventSetting = useRecoilValue(userEventSettings);
  const { execute: setFontSize } = useSetFontSize(gridType);

  const currentFontSize = userEventSetting[gridSettingsKeyMap[gridType]].fontSize;

  return (
    <FormControl size='small'>
      <Select
        value={currentFontSize}
        onChange={(e) => setFontSize(e.target.value as FontSize)}
        sx={{
          height: '40px',
          fontWeight: 400,
          color: 'inherit',
          fontSize: '.88rem',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#C7D1D4' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#C7D1D4' },
        }}
        displayEmpty
        renderValue={(value) => t(`font-size-${value}`)}
      >
        {FONT_SIZE_OPTIONS.map(({ value, labelKey }) => (
          <MenuItem key={value} value={value}>
            {t(labelKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
